namespace JupitersChoice {
    export class InitEventGatesCmd {

        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameConfig') _gameConfig: Sapphire.GameConfig;

        private _eventsLoaded: number = 0;

        execute(): void {
            const loginData = this._gameConfig.get('login');
            const isRecovering = loginData.refresh && loginData.refresh.restoreState;
            const eventsRequiredToPlay = [
                'onStageLoaded:BaseGame'
            ];

            // if recovering then we need to ensure all super bundles have loaded
            if (isRecovering) {
                eventsRequiredToPlay.push('onStageLoaded:FreeGame');
            }

            eventsRequiredToPlay.forEach(event => {
                this._eventManager.on(event, () => {
                    this._eventsLoaded++;

                    if (this._eventsLoaded >= eventsRequiredToPlay.length) {
                        // allow the finished logo to be visible for a little bit before showing splash
                        TweenMax.delayedCall(1, () => {
                            this._eventManager.publish('onEssentialAssetsLoaded');
                        });
                    }
                });
            });
        }
    }
}